import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'open-resource-in-tab-win',
  template: `
    <span fxFlex>
      <button
        fxFlex
        type="button"
        mat-button
        class="grid-text-centred three-c-grey"
        [matTooltip]="'MESSAGESANDWARNINGS.opensNewTab' | translate"
        (click)="triggerLinkButtonAction()"
        *ngIf="value"
      >
        <span fxFlex></span>
        <mat-icon>open_in_new</mat-icon>
        <span fxFlex></span>
      </button>
    </span>
  `,
  styles: [],
})
export class OpenResourceInNewTabOrWindowComponent implements ICellRendererAngularComp {
  public value: string;

  private popOpenTypes = {
    newTab: 'new tab',
    newWindow: 'new window',
  };

  constructor() {}

  agInit(params: ICellRendererParams) {
    this.value = params.value;
  }

  triggerLinkButtonAction() {
    setTimeout(() => {
      if (this.value) {
        if (this.value.toLowerCase() === this.popOpenTypes.newTab) {
          window.open('#/resource-preview');
        } else if (this.value.toLowerCase() === this.popOpenTypes.newTab) {
          window.open('#/resource-preview', '_blank', 'location=0');
        }
      }
    }, 100); // <-- Wait for selectedRow to be up-to-date
  }

  refresh(): boolean {
    return false;
  }
}
